import {Config} from "../types/Config.types";

const env = process.env.NODE_ENV || 'development';

export const config: Config = require(`./${env}.config.ts`).configuration;
